// zod's classic entry runs `config(en())` when it initializes, so it has to be
// imported before we override the locale. The locale is imported directly
// because `z.locales` is a barrel that pulls all 50 locales (~1.2MB).
import "zod";
import { config } from "zod/v4/core";
import es from "zod/v4/locales/es.js";

config(es());
